<script setup lang="ts"></script>

<template>
  <div class="flex justify-center items-center">
    {{ $t('common.noElementsSelected') }}
  </div>
</template>
